const noop = () => {};

if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined' && window.console) {
  [
    'assert',
    'clear',
    'count',
    'countReset',
    'debug',
    'dir',
    'dirxml',
    'error',
    'group',
    'groupCollapsed',
    'groupEnd',
    'info',
    'log',
    'profile',
    'profileEnd',
    'table',
    'time',
    'timeEnd',
    'timeLog',
    'trace',
    'warn',
  ].forEach((method) => {
    window.console[method] = noop;
  });
}
